<template>
  <div class="body">
    <div style="width: 100%; background: white;">
			<div class="container platform business-loan">
				<div class="row business-loan-box american-credit-partner">
					<div class="col-12 col-lg-5 offset-lg-1">
						<div class="business-loan-box-left-inner">
							<h1>The American <br>Credit<sup>®</sup> team</h1>
							<button @click="this.window.location.href='/get-start'" style="background-color: rgb(84, 86, 255); color: #ffffff; font-size: 16px; font-weight: 700; height: 53px; width: 169px; border-radius: 26.5px; border: none;">Apply Now</button>
							<p style="font-size: 18px; line-height: 30px; margin-top: 30px;"><span style="color: #696969; font-weight: 400;">Get the credit you deserve from a lender you can trust. </span><span style="color: #5456ff; font-weight: 700;"><a href="/get-start">Get Started <i class="fa fa-long-arrow-right"></i></a></span></p>
							<br />
						</div>
					</div>
					<div class="col-12 col-lg-5 business-loan-box-right">
						<img class="american-credit-team-head-img" src="../assets/imgs/American_Credit_Team_Member.png" alt="American Credit Senior Advisor Ronald Pelosi"/>
					</div>
				</div>
			</div>
		</div>

    <div style="width: 100%; background: #053a7a;">
      <div class="container bluebg text-center">
        <br />
        <h1 class="display-5 text-whitee text-center font-weight-bolder">One fine team, one great goal</h1>
        <div class="contexbox text-center">
          <br />
          <span class="h5 font-weight-bold">
            Getting you the secured business loan you need is what we’re all about.
          </span>
          <br />
          <br />
          <h6 class="text-whitee">
            American Credit’s team is as diverse as the small business community it serves. We bring together a wide range of skills and personalities—all dedicated to delivering equipment loans and invoice/AR financing for your business, reflecting expertise in everything from finance, security and IT to support and customer service, our team members have one focus: You.
          </h6>
        </div>
        <br />
        <br />
      </div>
    </div>

    <div style="width: 100%; background: white;">
      <div class="container whitebg text-center">
        <div class="contexbox text-center">
          <br>
          <br><a name="team">
          <h1 class="darkbluefont font-weight-bolder"><a href="/team#team">Meet the American Credit core team</a></h1>
        </a>
        <br>
          <br>
          <br>
          <div>
            <img style="box-shadow: 0 2px 5px rgba(0,0,0,.15); border-radius: 49.9%;" src="../assets/imgs/Ronald_Pelosi.png" class="img-responsive center-block" alt="American Credit Senior Advisor Ronald Pelosi"/>
          </div>
          <br>
          <span class="h5 darkbluefont font-weight-bold">Ronald Pelosi</span>
          <br>
          <span class="h5 darkbluefont font-weight-bold">Senior Advisor</span>
          <br>
          <br>
          <div class="h6 text-center">
            <br>
            <br>
            <ul>
              <li>
                President, Forward Funds, Diversified Mutual Fund Group
                <br>
                <br>
              </li>
              <li>
                President, Webster Investment Management Company
                <br>
                <br>
              </li>
              <li>
                Partner, Korn/Ferry International
                <br>
                <br>
              </li>
              <li>
                Senior Advisor, Social Finance (SoFi)
                <br>
                <br>
              </li>
              <li>
                Mediator, Financial Industry Regulatory Authority (FINRA)
                <br>
                <br>
              </li>
              <li>
                Arbitrator, American Arbitration Association
                <br>
                <br>
              </li>
              <li>
                President and Member, San Francisco Board of Supervisors
                <br>
                <br>
              </li>
              <li>
                President and Member, San Francisco City Planning Commission
                <br>
                <br>
              </li>
              <li>
                Chairman of the Board, San Francisco Employees’ Retirement System
                <br>
                <br>
              </li>
              <li>
                Board of Directors, Golden Gate Bridge Highway and Transportation District
                <br>
                <br>
              </li>
              <li>
                Board of Directors, Association of Bay Area Governments
                <br>
                <br>
              </li>
              <li>
                Board of Directors, League of California Cities
                <br>
                <br>
              </li>
              <li>
                Standing guest lecturer, Mediation for Dispute Resolution, Stanford University
                <br>
                <br>
              </li>
              <li>
                Stanford University, BA, American History
                <br>
                <br>
              </li>
            </ul>
          </div>
          </div>
      </div>
    </div>

    <div style="width: 100%; background: white;">
      <div class="container platform how-works">
        <div class="row how-works-button">
          <button @click="this.window.location.href='/get-start'" style="background-color: rgb(84, 86, 255); color: #ffffff; font-size: 16px; font-weight: 700; height: 53px; width: 169px; border-radius: 26.5px; border: none; margin: 7px;">Apply Now</button>
          <button @click="this.window.open('https://youtu.be/JH96Q66Y4Hc','_blank')" style="background-color: #ffffff; color: rgb(84, 86, 255); font-size: 16px; font-weight: 700; height: 53px; width: 169px; border-radius: 26.5px; border: 1px solid rgb(84, 86, 255); margin: 7px;">Watch Demo</button>
        </div>
      </div>
    </div>

    <div style="width: 100%;">
      <div class="row user-feedback">
        <div class="col-2 col-lg-4" style="background-color: #00234d;"></div>
        <div class="col-10 col-lg-8" style="background-color: #f6f9ff;"></div>
        <div class="container row user-feedback-content">
          <div class="col-12 col-lg-5 offset-lg-1 user-feedback-content-left">
            <img src="../assets/imgs/American_Credit_Team_Customer_Voice.png" alt="American Credit Team Customer Voice"/>
          </div>
          <div class="col-10 offset-2 col-lg-5 offset-lg-0 user-feedback-content-right">
            <img src="../assets/imgs/quote.png" alt="American Credit Team Customer Voice Quote">
            <p class="user-feedback-text">I need to spend my time meeting customers’ expectations, not on lengthy loan applications.</p>
            <br>
            <br>
            <p  class="user-feedback-name"><span style="color: #6d6d6d; font-weight: 300;">Laurie Townsend</span><br><span style="color: #3c3c3c; font-weight: 700;">Account Receivable Manager, Lone Star Uniform Services</span></p>
            <div class="user-feedback-button">
              <button @click="this.window.location.href='tel:1855-904-0188'">Let’s Talk</button>
              <p><span style="color: #3c3c3c; font-weight: 300;">Try us now. </span><span style="color: #3c3c3c; font-weight: 700;">See how we get you the money fast. </span><span style="color: #5456ff; font-weight: 700;"><a href="/get-start">Get Started <i class="fa fa-long-arrow-right"></i></a></span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import * as types from "../vuex/types";
import api from "../vuex/api/index";

export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {
    var seo = document.getElementById("seo");

    var meta = document.getElementById("seometa");
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      meta.id = "seometa";
      document.head.insertBefore(meta, seo);
    }

    var keywords = document.getElementById("seokeywords");
    if (!keywords) {
      keywords = document.createElement("meta");
      keywords.name = "keywords";
      keywords.id = "seokeywords";
      document.head.insertBefore(keywords, seo);
    }

    document.title = "Ronald Pelosi | Senior Advisor | American Credit";
    meta.content =
      "Meet American Credit's founding team member. One great team, one great goal of quickly getting you the secured business loan you need.";
    keywords.content =
      "secured business loan, Ronald Pelosi, american credit";
  }
};
</script>

<style scoped lang="scss">
  @import "../assets/css/global.scss";
  @import "../assets/css/fonts.css";

  .american-credit-team-head-img {
    width: 720px !important;
    margin-top: 120px !important;
  }

  @media screen and (max-width: 767px) {

    .american-credit-team-head-img {
      width: 100% !important;
      margin-top: 0px !important;
      margin-bottom: 50px !important;
    }
  }
</style>


// WEBPACK FOOTER //
// ronald.vue?4b1ccd9a